// components/DeleteConfirmationModal.js
import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, groupName, customMessage, isWarning }) => {
  return (
    <Modal open={open} onClose={onClose} style={{zIndex:1000}}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "50%",
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      }}>
        <Typography variant="h6" component="h2">
          {isWarning ? 'Warning' : 'Confirm Deletion'}
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {customMessage || `Are you sure you want to delete the business group ${groupName}?`}
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: isWarning ? 'center' : 'space-between' }}>
          {!isWarning && (
            <Button variant="contained" color="primary" onClick={onClose}>
              Cancel
            </Button>
          )}
          <Button 
            variant="contained" 
            color={isWarning ? "primary" : "error"} 
            onClick={isWarning ? onClose : onConfirm}
          >
            {isWarning ? 'OK' : 'Delete'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmationModal;
